import { forwardRef, useEffect, useState } from 'react'
import useOrderStore from 'store/client/orderStore'
import { twMerge } from 'tailwind-merge'

const LabelCardHome = ({ children, className, type, number, isHursan,isZorlu }, ref) => {
  const { referance } = useOrderStore()
  const [height, setHeight] = useState(0)
  const [width, setWidth] = useState(0)
  const isBlackLabel = referance?.backgroundColor === 'B'

  // isZorlu true ise type'ı ters çevir
  const actualType = isZorlu ? (type === 'front' ? 'back' : 'front') : type
  
  const cn = twMerge(
    `border-[0.5px] ${isHursan ? 'border-transparent' : 'border-[#ee1d25]'} relative text-[4.7pt] font-arial ${
      isBlackLabel && 'bg-black text-white'
    } ${number === 1 ? 'border-none' : ''}`, // Koşullu sınıf ekle
    className
  )

  useEffect(() => {
    if (referance) {
      setHeight(referance.height)
      setWidth(referance.width)
    }
  }, [referance])


  return (
    <div
      ref={ref}
      className={cn}
      style={{
        width: `${width}mm`,
        height: `${height}mm`
      }}
    >
    <div style={{position:"absolute",top:"0",left:"0",width:"1mm",height:"100%",backgroundColor:"black",display:isZorlu ? "block" : "none"}}>
      
    </div>

    <div style={{position:"absolute",top:"0",right:"-1mm",width:"1mm",height:"100%",backgroundColor:"black",display:isZorlu ? "block" : "none"}}>
      
      </div>
      <div
        style={{
          right: actualType === 'front' ? '12mm' : 'auto',
          left: actualType === 'front' ? 'auto' : '12mm',
          borderColor: number === 1 || isHursan ? "transparent" : "#ee1d25",
          borderWidth: "0.1px"

        }}
        className={`absolute h-full w-[0.1px]  border-s border `}
     
      ></div>
      <div
        style={{
          right: actualType === 'front' ? '1mm' : 'auto',
          left: actualType === 'front' ? 'auto' : '1mm'
        }}
        className="absolute bottom-0 text-[#E05AAB] bottor"
      >
        
      </div>
      <div
        style={{
          right: actualType === 'front' ? '1mm' : 'auto',
          left: actualType === 'front' ? 'auto' : '1mm'
        }}
        className={`absolute top-1/2 h-8 w-1 -translate-y-1/2 `}
      />
      <div className="flex h-full">
        <div
          style={{
            paddingLeft: actualType === 'front' ? '0mm' : '12mm',
            paddingRight: actualType === 'front' ? '12mm' : '0mm'
          }}
          className="w-full"
        >
          {children}
        </div>
      </div>
    </div>
  )
}

export default forwardRef(LabelCardHome)
